__turbopack_context__.v({
  "component": "BannerList-module__rwpC3W__component",
  "component__body": "BannerList-module__rwpC3W__component__body",
  "component__btn": "BannerList-module__rwpC3W__component__btn",
  "component__heading": "BannerList-module__rwpC3W__component__heading",
  "component__heading__dark": "BannerList-module__rwpC3W__component__heading__dark",
  "component__heading__red": "BannerList-module__rwpC3W__component__heading__red",
  "component__icon": "BannerList-module__rwpC3W__component__icon",
  "component__icon__dark": "BannerList-module__rwpC3W__component__icon__dark",
  "component__icon__red": "BannerList-module__rwpC3W__component__icon__red",
  "component__list": "BannerList-module__rwpC3W__component__list",
  "component__listCopy": "BannerList-module__rwpC3W__component__listCopy",
  "component__listItem": "BannerList-module__rwpC3W__component__listItem",
  "hide-for-large": "BannerList-module__rwpC3W__hide-for-large",
  "hide-for-large-only": "BannerList-module__rwpC3W__hide-for-large-only",
  "hide-for-medium": "BannerList-module__rwpC3W__hide-for-medium",
  "hide-for-medium-only": "BannerList-module__rwpC3W__hide-for-medium-only",
  "hide-for-small-only": "BannerList-module__rwpC3W__hide-for-small-only",
  "show-for-large": "BannerList-module__rwpC3W__show-for-large",
  "show-for-large-only": "BannerList-module__rwpC3W__show-for-large-only",
  "show-for-medium": "BannerList-module__rwpC3W__show-for-medium",
  "show-for-medium-only": "BannerList-module__rwpC3W__show-for-medium-only",
  "show-for-small-only": "BannerList-module__rwpC3W__show-for-small-only",
  "u-color-black": "BannerList-module__rwpC3W__u-color-black",
  "u-color-blue": "BannerList-module__rwpC3W__u-color-blue",
  "u-color-midnight": "BannerList-module__rwpC3W__u-color-midnight",
  "u-color-primary-dark": "BannerList-module__rwpC3W__u-color-primary-dark",
  "u-color-red": "BannerList-module__rwpC3W__u-color-red",
  "u-color-white": "BannerList-module__rwpC3W__u-color-white",
  "u-theme-black": "BannerList-module__rwpC3W__u-theme-black",
  "u-theme-blue": "BannerList-module__rwpC3W__u-theme-blue",
  "u-theme-dark": "BannerList-module__rwpC3W__u-theme-dark",
  "u-theme-light": "BannerList-module__rwpC3W__u-theme-light",
  "u-theme-red": "BannerList-module__rwpC3W__u-theme-red",
  "u-theme-white": "BannerList-module__rwpC3W__u-theme-white",
});
